import { alpha, type Theme } from "@mui/material/styles"

const SUBTLE_SHADOW_OPACITY = {
  dark: 0.14,
  light: 0.05,
} as const

const SUBTLE_EDGE_SHADOW_OPACITY = {
  dark: 0.28,
  light: 0.12,
} as const

export const getSubtleSurfaceShadow = (theme: Theme) =>
  `0 ${theme.spacing(0.125)} ${theme.spacing(0.25)} ${alpha(
    theme.palette.common.black,
    SUBTLE_SHADOW_OPACITY[theme.palette.mode],
  )}`

export const getSubtleEdgeShadow = (theme: Theme, edge: "left" | "right") => {
  const offset = edge === "left" ? theme.spacing(0.375) : `-${theme.spacing(0.375)}`

  return `${offset} 0 ${theme.spacing(0.75)} -${theme.spacing(0.25)} ${alpha(
    theme.palette.common.black,
    SUBTLE_EDGE_SHADOW_OPACITY[theme.palette.mode],
  )}`
}
